import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

const portfolioEntitlementFields = {
  energy: 'subscribedEnergy',
  metals: 'subscribedMetals',
  retail: 'subscribedRetail',
  tech: 'subscribedTech',
};

function hasPortfolioAccess(userProfile, requiredPortfolio) {
  if (!requiredPortfolio) {
    return true;
  }

  const entitlementField = portfolioEntitlementFields[requiredPortfolio];
  return Boolean(entitlementField && userProfile?.[entitlementField] === true);
}

const ProtectedRoute = ({ children, requiredPortfolio }) => {
  const { user, userProfile, authLoading } = UserAuth();
  const location = useLocation();

  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#12181B] text-sm font-semibold text-white/55" role="status">
        Loading your account…
      </div>
    );
  }

  if (!user) {
    return <Navigate to='/' replace />;
  }

  if (!user.emailVerified) {
    return <Navigate to="/signup" replace state={{ ...location.state, returnTo: location.pathname + location.search }} />;
  }

  if (!hasPortfolioAccess(userProfile, requiredPortfolio)) {
    return (
      <Navigate
        to='/account'
        replace
        state={{ blockedPortfolio: requiredPortfolio }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
